const cache = new Map();

export const cacheData = (key, data, ttl = 5 * 60 * 1000) => { // 5 minutes default TTL
  cache.set(key, {
    data,
    expiry: Date.now() + ttl
  });
};

export const getCachedData = (key) => {
  const cached = cache.get(key);
  if (!cached) return null;
  if (Date.now() > cached.expiry) {
    cache.delete(key);
    return null;
  }
  return cached.data;
}; 